import { PolicyBank } from "./policy-bank";
import { PolicyDevice } from "./policy-device";
import { CustomerInfo } from "../customer/customer-info";
import { CCPaymentInfo } from "../sales/payment-methods/cc-payment-info";
import { PolicyPayment } from "./policy-payment";
import { DealerProductsType } from "../common";

export class PolicyDetails {

  //constructor(
    public PolicyNumber: string;
    public ProductCode: string;
    public ProductDescription: string;
    public CompanyCode: string;
    public DealerCode: string;
    public BranchCode: string;
    public PolicyId: string;
    public PolicyPrice: number;
    public SalesPrice: number;
    public SalesTax: number;
    public GrossPremium: number;
    public NetPremium: number;
    public PremiumType: string;
    public ProductSalesDate: Date;
    public Statuscode: string;
    public SKUNumber: string;

    public WarrantySalesDate: Date;
    public WarrantyDurationMfg: number;
    public WarrantyDurationExt: number;
    public BillingCycle: number;
    public BillingFrequency: number;
    public InstallmentAmount: number;
    public InstallmentCount: number;
    public InvoiceNumber: string;
    public PaymentType: string;
    public PaymentInstrumentType: string;
    public PaymentNumber: string;
    public PolicyType: string;
    public PolicyStatus: string;
    public PolicyDescription: string;
    public SalesRep: string;
    public SalesRepEmail: string;
    public CustomerPurchaser: string;
    public StoreGroupId: string;
    public StoreId: string;
    public BatchProcessedDate: Date;

    public BatchType: string;
    public BatchStatusCode: string;
    public IsUpgradeProduct: boolean;
    public CurrencyCode: string;
    public DeductiblePercent: number;
    public DeductibleReplace: number;
    public DeductibleRepair: number;
    public EffectiveDate: Date;
    public ExpiredDate: Date;
    public NextBillingDate: Date;
    public PaidThroughDate: Date;
    public IsPolicyTypeGadget: boolean;
    public IsPolicyTypeSericeOffer: boolean;

    public Bank: PolicyBank;
    public Device: PolicyDevice;
    public Customers: CustomerInfo[];
    public Payment: PolicyPayment;
    SalesInsuranceType?: DealerProductsType;
    public CertificateDate? :string ;
  //) {}
}
